import {Component, ViewChild} from '@angular/core';
import {DataTable} from '../../services/DataTable';
import {ClientsService} from '../../models/clients/clients.service';
import {ClientStatusType} from '../../models/clients/clients.type';
import {PricingsService} from '../../models/pricings/pricings.service';
import {Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {BadgesService} from '../../models/badges/badges.service';
import {BadgesHelper} from '../../services/BadgesHelper';
import {IClientModel} from "../../models/clients/clients.model";


@Component({
    selector: 'pricing-table',
    templateUrl: 'pricing-table.template.html'
})
export class PricingTableComponent 
{
    @ViewChild('createSchedule') public createSchedule;
    @ViewChild('snowNotes') public snowNotes;

    public dataTable: DataTable;
    public statuses: Array<any> = [];

    public status: ClientStatusType = ClientStatusType.INCOMPLETE;
    public withStatusChange: any = false;


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public clientsService: ClientsService,
        public pricingsService: PricingsService,
        public badgesService:BadgesService,
        public badgesHelper: BadgesHelper
    ) {

        this.status = this.route.snapshot.data['status'];
        this.withStatusChange = this.route.snapshot.data['withStatusChange'];

        switch (this.status) {
            case ClientStatusType.INCOMPLETE:
                this.statuses = this.clientsService.getStatusIncomplete();
                break;
            case ClientStatusType.AGREEMENT_IN:
                this.statuses = this.clientsService.getStatusAgreementIn();
                break;
            case ClientStatusType.COMPLETE:
                this.statuses = this.clientsService.getStatusComplete();
                break;
            case ClientStatusType.APPROVED_BY_DE:
                this.statuses = this.clientsService.getStatusApprovedByDE();
                break;
            case ClientStatusType.AGREEMENT_OUT:
                this.statuses = this.clientsService.getStatusAgreementOut();
                break;
            case ClientStatusType.APPROVED_NOT_FUNDED:
                this.statuses = this.clientsService.getStatusApproved();
                break;
        }


        this.dataTable = new DataTable(this.pricingsService, this.getFields());
        ((() => {
            var a: any = document.createElement('a');
            a.href = router.url;
            var url: any = new URL(a.href);
            var q = url.searchParams.get('q');
            return (dataTable: any) => {
                if (q) dataTable.filter.q = q;
            };
        }) ()) (this.dataTable);
        this.dataTable.fetch();

        this.badgesService.onChange.subscribe((badgesObject)=> {
            badgesHelper.refreshEntity(badgesObject, this.dataTable);
            this.refreshTable();
        });
    }

    ngOnInit() {

    }

    // ===========================================================
    // Actions
    // ===========================================================

    public openOne(model) {
        this.router.navigate(['pricing/' + model.id + '/client/' + model.client_id], {relativeTo: this.route})
    }

    public showCreateSchedule(entity:IClientModel) {
        this.createSchedule.show(entity);
    }

    public openNotesModal(entity:IClientModel, event) {
        this.snowNotes.show(entity);
        this.badgesService.removeChannel('clients/' + entity.id  + '/notes');
    }

    // ===========================================================
    // Functions
    // ===========================================================

    public refreshTable() {
        this.dataTable.refresh();
    }

    private getFields() {
        return [{'client_status': this.status}];
    }

    get createdAtType() {
        var isFS = () => {
            return /^\/funding-specialist\//gui.test(this.router.url);
        };
        var isIncomplete = () => {
            return /^\/[^\/]+\/incomplete(\?[\s\S]*|)/gui.test(this.router.url);
        };
        if (isFS() && isIncomplete()) {
            return 'incompleted_at';
        }
    }

    dateFromUnix(t: any): any {
        try {
            return new Date(t * 1000).toString();
        } catch (e) {}
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/pricing-table/pricing-table.component.ts